// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IProofOfExpensesTypePropertyDto
 */
export interface IProofOfExpensesTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IProofOfExpensesTypePropertyDto
     */
    proof_of_expenses_type?: IProofOfExpensesTypePropertyDtoProofOfExpensesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IProofOfExpensesTypePropertyDto
     */
    proof_of_expenses_type_state?: IProofOfExpensesTypePropertyDtoProofOfExpensesTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IProofOfExpensesTypePropertyDtoProofOfExpensesTypeEnum {
    RECEIPT_REQUIRED = 'RECEIPT_REQUIRED',
    NO_RECEIPT_REQUIRED = 'NO_RECEIPT_REQUIRED'
}
/**
* @export
* @enum {string}
*/
export enum IProofOfExpensesTypePropertyDtoProofOfExpensesTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IProofOfExpensesTypePropertyDto interface.
 */
export function instanceOfIProofOfExpensesTypePropertyDto(value: object): value is IProofOfExpensesTypePropertyDto {
    return true;
}

export function IProofOfExpensesTypePropertyDtoFromJSON(json: any): IProofOfExpensesTypePropertyDto {
    return IProofOfExpensesTypePropertyDtoFromJSONTyped(json, false);
}

export function IProofOfExpensesTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProofOfExpensesTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'proof_of_expenses_type': json['proof_of_expenses_type'] == null ? undefined : json['proof_of_expenses_type'],
        'proof_of_expenses_type_state': json['proof_of_expenses_type_state'] == null ? undefined : json['proof_of_expenses_type_state'],
    };
}

export function IProofOfExpensesTypePropertyDtoToJSON(json: any): IProofOfExpensesTypePropertyDto {
    return IProofOfExpensesTypePropertyDtoToJSONTyped(json, false);
}

export function IProofOfExpensesTypePropertyDtoToJSONTyped(value?: IProofOfExpensesTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proof_of_expenses_type': value['proof_of_expenses_type'],
        'proof_of_expenses_type_state': value['proof_of_expenses_type_state'],
    };
}

